import { MedicineRawMaterialSimple, MedicineRawMaterialSimpleQuery } from '@dreryk/drerykweb-medicine-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Bean, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { magistralDrugTranslationKeys } from '../../../../../../translations';

const MedicineRawMaterialItemRenderer = (medicine: MedicineRawMaterialSimple): JSX.Element => {
   return (
      <>
         {medicine.name}
         {` (${medicine.nameForPrescription})`}
      </>
   );
};

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
   maxLength: 200,
};

const medicineRawMaterialsSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<MedicineRawMaterialSimple[]> =>
      performCqrsQuerySearch<MedicineRawMaterialSimple>(() => {
         const query = new MedicineRawMaterialSimpleQuery();
         if (searchText) {
            query.searchText = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      }, paginations.all<MedicineRawMaterialSimple>().orderedBy('nameForPrescription', paginations.Direction.ASCENDING));
};

const textInputValueExtractor = (medicine: MedicineRawMaterialSimple): string =>
   `${medicine.name} (${medicine.nameForPrescription})`;
const keyExtractor = (medicine: MedicineRawMaterialSimple): number => medicine.id;

export const MedicineRawMaterialNameAutocompleteCell = (
   props: InteractiveTableCellProps<string | MedicineRawMaterialSimple>
): JSX.Element => {
   return (
      <InteractiveTable.AutocompleteCell<MedicineRawMaterialSimple>
         testId={props.testId}
         name={props.name}
         index={props.index}
         validationRules={VALIDATION_RULES}
         defaultValue={props.defaultValue}
         placeholder={magistralDrugTranslationKeys.medicineRawMaterials.columns.namePlaceholder}
         keyExtractor={keyExtractor}
         textInputValueExtractor={textInputValueExtractor}
         itemRenderer={MedicineRawMaterialItemRenderer}
         searchCreator={medicineRawMaterialsSearchCreator}
      />
   );
};
